
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planter-toolkit",
      function () {
        return require("private-next-pages/planter-toolkit/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planter-toolkit"])
      });
    }
  